// OFFLINE
export const baseUrl = 'https://test-api-v8gp.onrender.com';

// export const baseUrl = 'http://127.0.0.1:8000';

